module.exports = __webpack_public_path__ + "img/WMStwo.8eec5738.png";